import { useState, useEffect } from 'react';

/**
 * True when UI should prefer tap/expand over hover-only (touchscreens + narrow layouts).
 */
export function useTouchFriendlyUI(narrowMaxWidth = 968) {
  const [useTapMenus, setUseTapMenus] = useState(false);

  useEffect(() => {
    const coarseMq = window.matchMedia('(hover: none), (pointer: coarse)');
    const narrowMq = window.matchMedia(`(max-width: ${narrowMaxWidth}px)`);
    const update = () => setUseTapMenus(coarseMq.matches || narrowMq.matches);

    update();

    if (coarseMq.addEventListener) {
      coarseMq.addEventListener('change', update);
      narrowMq.addEventListener('change', update);
      return () => {
        coarseMq.removeEventListener('change', update);
        narrowMq.removeEventListener('change', update);
      };
    }

    coarseMq.addListener(update);
    narrowMq.addListener(update);
    return () => {
      coarseMq.removeListener(update);
      narrowMq.removeListener(update);
    };
  }, [narrowMaxWidth]);

  return useTapMenus;
}
